// 用户
export default [{ // 心理热线
  path: '/psychologicalHotline',
  name: 'psychologicalHotline',
  component: resolve => require(['@/views/psychologicalHotline/psychologicalHotline.vue'], resolve),
  meta: {
    group: "/psychologicalHotline",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, { // 添加心理热线
  path: '/addPsychologicalHotline',
  name: 'addPsychologicalHotline',
  component: resolve => require(['@/views/psychologicalHotline/addPsychologicalHotline.vue'], resolve),
  meta: {
    group: "/psychologicalHotline",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, { // 编辑心理热线
  path: '/editPsychologicalHotline/:id',
  name: 'editPsychologicalHotline',
  component: resolve => require(['@/views/psychologicalHotline/addPsychologicalHotline.vue'], resolve),
  meta: {
    group: "/psychologicalHotline",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}]


// WEBPACK FOOTER //
// ./src/router/psychologicalHotline/psychologicalHotline.js